import {
  WSCard,
  WSControl,
  WSForm,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { useCustomization } from "../../../modules/customization";
import { InstantPayoutPayoutCA } from "../../../modules/Settings/components/InstantPayoutPayoutCA";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayoutSettings } from "../../../query/payments/queries";
import { selectorInstantPayoutDefaultFee } from "../../selectors/selectorInstantPayoutDefaultFee";

export const IPSupport = () => {
  const userId = useUserId();
  const queryPayoutSettings = useQueryPayoutSettings(userId);
  const ipFee = selectorInstantPayoutDefaultFee(queryPayoutSettings.data);
  const { support } = useCustomization();

  return (
    <WSCard header="Instant payouts (optional)">
      <WSList gap="XL">
        <WSInfoBox>
          This account may have instant payouts available. Please check your
          financial institution’s online banking portal as some banks may
          require you to opt-in or enable the service manually.
        </WSInfoBox>

        <InstantPayoutPayoutCA />

        <WSList gap="S">
          <WSForm.Field
            name="useAsDefaultIPMethod"
            component={WSControl}
            componentProps={{
              type: "checkbox",
              label: `Set instant payout (${ipFee}% fee) as default for all payouts*`
            }}
          />
          <WSText.ParagraphXs color="gray400">
            *Instant payouts allow you to receive payments faster than standard
            payouts for a 2% fee. You can set instant payout as your default for
            all payouts or request an instant payout on a per invoice basis.
            These settings can be updated in your account settings any time.
            Instant payouts only work with bank accounts or debit cards that
            participate in instant transfer services.
          </WSText.ParagraphXs>
          <WSText.ParagraphXs color="gray400">
            All refunds are processed in accordance with the{" "}
            <a
              href={support(true).documentation.refundPolicyUrl}
              target="_blank"
              rel="noreferrer"
            >
              Refund Policy
            </a>
          </WSText.ParagraphXs>
        </WSList>
      </WSList>
    </WSCard>
  );
};
